import { render, staticRenderFns } from "./BookmarkModals.vue?vue&type=template&id=1806231a&"
import script from "./BookmarkModals.vue?vue&type=script&lang=js&"
export * from "./BookmarkModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports